import type { RootState } from 'APP/Store/CreateStore'

export const selectEligibilitySearchResults = (state: RootState) => state.eligibilitySearch.results
export const selectEligibilitySearchLoading = (state: RootState) => state.eligibilitySearch.loading
export const selectEligibilitySearchError = (state: RootState) => state.eligibilitySearch.error
export const selectEnrolWithOrganizationIdLoading = (state: RootState) =>
  state.eligibilitySearch.enrolWithOrganizationIdLoading
export const selectEnrolWithOrganizationIdSuccess = (state: RootState) =>
  state.eligibilitySearch.enrolWithOrganizationIdSuccess
export const selectEnrolWithOrganizationIdError = (state: RootState) =>
  state.eligibilitySearch.enrolWithOrganizationIdError
export const selectEligibilityAccessVerificationLoading = (state: RootState) =>
  state.eligibilitySearch.accessVerificationLoading
